var ddlYears=$("#select_year");var currentYear=new Date().getFullYear();for(var i=1982;i<=currentYear;i++){var option=$("<option />");option.html(i);option.val(i);ddlYears.append(option)}
$("body").on("click",".tz-discount-btn",function(){var value=$(this).val();var tz_quantity_selector=$("quantity-selector").find(".quantity-selector__input").val(value)});$(function(){$("#discount-text").click(function(){if($(this).is(":checked"))$(".discountcodefield").removeClass("hide");else $(".discountcodefield").addClass("hide")})});$(document).ready(function(){$(".discount_code_btn").click(function(){var discountStored=$('input[name="discount_code"]').val();$('input[name="discount"]').val(discountStored);$(".discount_apply_code").html('<div><svg class="icon-sale-tag-2" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 350 350" fill="none">      <path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M0 197.826C0 192.95 1.93821 188.275 5.38762 184.83L179.459 10.7587C186.348 3.86966 195.692 -0.000356971 205.435 2.46966e-08H334.782C343.187 2.46966e-08 350 6.81304 350 15.2173V144.565C350 154.308 346.13 163.651 339.241 170.541L165.17 344.612C161.725 348.061 157.049 350 152.174 350C147.299 350 142.624 348.061 139.179 344.612L5.38762 210.821C1.93821 207.376 0 202.701 0 197.826ZM304.348 68.4786C304.348 81.085 294.128 91.3046 281.521 91.3046C268.915 91.3046 258.695 81.085 258.695 68.4786C258.695 55.8721 268.915 45.6525 281.521 45.6525C294.128 45.6525 304.348 55.8721 304.348 68.4786Z"></path></svg><strong>'+discountStored+'</strong> applied on checkout page. <a href="javascript:void(0);" class="clear-discount">Remove</a></div>');if(String(discountStored).trim().toUpperCase()==="WELCOME5"){localStorage.removeItem("storedDiscount")}else{localStorage.setItem("storedDiscount",discountStored)};$('input[name="discount_code"]').val("")});$(document).on("click","a.clear-discount",function(event){var discountStored="";$('input[name="discount"]').val(discountStored);$(".discount_apply_code").html("");var deletenum="storedDiscount";localStorage.removeItem(deletenum)});if(String(localStorage.getItem("storedDiscount")||"").trim().toUpperCase()==="WELCOME5"){localStorage.removeItem("storedDiscount")};if(localStorage.getItem("storedDiscount")){var discountStored=localStorage.getItem("storedDiscount");if(discountStored!=""&&discountStored!="undefined"){$('input[name="discount"]').val(localStorage.getItem("storedDiscount"));$(".discount_apply_code").html('<div><svg class="icon-sale-tag-2" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 350 350" fill="none">      <path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M0 197.826C0 192.95 1.93821 188.275 5.38762 184.83L179.459 10.7587C186.348 3.86966 195.692 -0.000356971 205.435 2.46966e-08H334.782C343.187 2.46966e-08 350 6.81304 350 15.2173V144.565C350 154.308 346.13 163.651 339.241 170.541L165.17 344.612C161.725 348.061 157.049 350 152.174 350C147.299 350 142.624 348.061 139.179 344.612L5.38762 210.821C1.93821 207.376 0 202.701 0 197.826ZM304.348 68.4786C304.348 81.085 294.128 91.3046 281.521 91.3046C268.915 91.3046 258.695 81.085 258.695 68.4786C258.695 55.8721 268.915 45.6525 281.521 45.6525C294.128 45.6525 304.348 55.8721 304.348 68.4786Z"></path></svg><strong>'+discountStored+'</strong> applied on checkout page. <a href="javascript:void(0);" class="clear-discount">Remove</a></div>')}}});(function(){var jquery=null;if(window.jQuery){jquery=window.jQuery}else if(window.Checkout&&window.Checkout.$){jquery=window.Checkout.$}
jquery(document).on("click","button.applied-reduction-code__clear-button",function(event){var deletenum="storedDiscount";localStorage.removeItem(deletenum);var url=window.location.href;console.log(url);var return_url=removeURLParameter(url,"discount");window.location.href=return_url});jquery(document).on("click","button.field__input-btn",function(event){var value=jquery("#checkout_reduction_code").val();updateQueryStringParam("discount",value)})})();function removeURLParameter(url,parameter){var urlparts=url.split("?");if(urlparts.length>=2){var prefix=encodeURIComponent(parameter)+"=";var pars=urlparts[1].split(/[&;]/g);for(var i=pars.length;i-->0;){if(pars[i].lastIndexOf(prefix,0)!==-1){pars.splice(i,1)}}
url=urlparts[0]+"?"+pars.join("&");return url}else{return url}}
function updateQueryStringParam(key,value){baseUrl=[location.protocol,"//",location.host,location.pathname].join("");urlQueryString=document.location.search;var newParam=key+"="+value,params="?"+newParam;if(urlQueryString){keyRegex=new RegExp("([?&])"+key+"[^&]*");if(urlQueryString.match(keyRegex)!==null){params=urlQueryString.replace(keyRegex,"$1"+newParam)}else{params=urlQueryString+"&"+newParam}}
window.history.replaceState({},"",baseUrl+params)}

document.addEventListener('DOMContentLoaded', function() {
  const chatLink = document.querySelector('a[href="#livechat"]');

  if (chatLink) {
    chatLink.addEventListener('click', function(event) {
      event.preventDefault(); // Prevent the browser from jumping to the anchor

      // Find the Shopify Inbox chat toggle button and click it
      // This selector might need to be adjusted based on your Shopify Inbox implementation
      const chatToggle = document?.getElementById('ShopifyChat')?.shadowRoot?.querySelector('.chat-app > button') ||
                         document?.getElementById('dummy-chat-button-iframe')?.contentWindow?.document?.querySelector('button');

      if (chatToggle) {
        chatToggle.click();
      } else {
        console.warn("Shopify Inbox chat toggle button not found. Please check the selector.");
      }
    });
  }
});

//Rajeev Code

(function () {
  const HASH = "#Gorgias";
  const MAX_RETRIES = 8;
  const RETRY_DELAY_MS = 250;

  // Try to call a method with retries until available or attempts exhausted
  function tryCall(fn, attempts = MAX_RETRIES) {
    return new Promise((resolve, reject) => {
      let tries = 0;
      (function attempt() {
        tries++;
        try {
          const res = fn();
          resolve(res);
        } catch (err) {
          if (tries >= attempts) return reject(err);
          setTimeout(attempt, RETRY_DELAY_MS);
        }
      })();
    });
  }

  // Best-effort open of Gorgias chat widget
  async function openGorgiasWidget() {
    // If GorgiasChat not available yet, retry a few times
    try {
      await tryCall(() => {
        if (typeof GorgiasChat === "undefined") throw new Error("GorgiasChat not ready");
        // If widget has isOpen property, we can try useful logic
        // Otherwise, we'll attempt close->open guarded by existence checks.
        try {
          // if GorgiasChat.isOpen exists and is true, attempt to close then reopen
          if (GorgiasChat.isOpen) {
            if (typeof GorgiasChat.close === "function") {
              GorgiasChat.close();
            }
          }
        } catch (e) {
          // ignore safe failures
        }

        // Finally call open (may be no-op if already open)
        if (typeof GorgiasChat.open === "function") {
          GorgiasChat.open();
          return true;
        }

        throw new Error("GorgiasChat.open not available");
      });
    } catch (err) {
      // final fallback: if widget not loaded, try to nudge by toggling hash (doesn't create duplicate history entry)
      try {
        if (location.hash === HASH) {
          // remove hash then set it to force state change without adding history
          history.replaceState(null, "", location.pathname + location.search);
          history.replaceState(null, "", location.pathname + location.search + HASH);
        } else {
          history.replaceState(null, "", location.pathname + location.search + HASH);
        }
      } catch (e) {
        // ignore
      }
      console.warn("Gorgias widget open attempt failed:", err);
    }
  }

  // On page load: if hash present, open
  function handleHashOnLoadOrChange() {
    if (location.hash === HASH) openGorgiasWidget();
  }

  // Click handler for links so same-hash clicks still open widget
  function clickHandler(e) {
    const el = e.target.closest && e.target.closest('a[href="#Gorgias"]');
    if (!el) return;
    e.preventDefault();               // prevent jump
    openGorgiasWidget();              // directly try to open
    // optionally keep the hash in address bar without adding to history:
    if (location.hash !== HASH) {
      try { history.replaceState(null, "", location.pathname + location.search + HASH); } catch (err) {}
    }
  }

  // Init listeners
  window.addEventListener("hashchange", handleHashOnLoadOrChange, false);
  document.addEventListener("click", clickHandler, false);

  // Run at load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", handleHashOnLoadOrChange);
  } else {
    handleHashOnLoadOrChange();
  }
})();

(function () {
  function moveHeaderLocalization() {
    var target = document.querySelector('[data-header-localization]');
    if (!target) return;

    var sourceWrapper = document.getElementById('shopify-section-static-utility-bar');
    var source = sourceWrapper && sourceWrapper.querySelector('[data-header-localization-source]');

    var existing = target.querySelectorAll('[data-header-localization-source]');

    if (!source) {
      existing.forEach(function (el) {
        el.remove();
      });
      return;
    }

    existing.forEach(function (el) {
      if (el !== source) el.remove();
    });

    target.appendChild(source);
  }

  function init() {
    moveHeaderLocalization();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(moveHeaderLocalization, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
